import React, { useEffect, useState } from 'react';
import { BLUEARROW_ICON, GREYARROW_ICON } from '../../../utills/image-constant';

const SidebarAccordion = ({ accordionItem, onSubDimensionClick,selectedSubDimenstion }) => {
  console.log('selectedSubId',selectedSubDimenstion);
  
  const [activeIndex, setActiveIndex] = useState({ 0: 0 });

const toggle = (outerIndex, index) => {
  setActiveIndex((prev) => {
    const isSame = prev[outerIndex] === index;
    const newState = {
      ...prev,
      [outerIndex]: isSame ? null : index,
    };
    return newState;
  });
};


  const handleSubItemClick = (subdimenstionId) => {
    if (subdimenstionId) {
      onSubDimensionClick(subdimenstionId);
    }
  };

 
  return (
    <div className='indivisual_sidebar'>
      <div className="sidebar-accordion">
        {accordionItem?.map((groupItem, outerIndex) => (
          <div key={outerIndex} className="accordion-group">
            {groupItem?.dimensionList?.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div className="accordion-header" onClick={() => toggle(outerIndex, index)}>
                  <strong>{item.dimensionName}</strong>
                  <span>
                    {activeIndex[outerIndex] === index ? (
                      <img src={BLUEARROW_ICON} alt="" className="mainuitemsimg ms-2" />
                    ) : (
                      <img src={GREYARROW_ICON} alt="" className="mainuitemsimg ms-2" />
                    )}
                  </span>
                </div>

                {activeIndex[outerIndex] === index && (
                  <div className="accordion-content">
                    <ul>
                      {item?.subDimensionList?.map((subItem, subIndex) => (
                        <li
                          key={subIndex}
                          onClick={() =>
                            handleSubItemClick(subItem.id)
                          }
                          className={selectedSubDimenstion === subItem.id ? 'activebold' : ''}
                          style={{ cursor: 'pointer' }}
                        >
                          {subItem.subDimensionName}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SidebarAccordion;
